import {Fourchette} from './Fourchette';
export class TypeMontantFourchette2 {

	public fourchette: Fourchette;

	public valeur: number;

	public devise: string;

	constructor() { 
		this.fourchette = new Fourchette();
		this.valeur = 0;
		this.devise = '';
 
	}
}
